import { FETCH_AUTOMATIONS, RESET_AUTOMATIONS } from '../actionTypes';

const initialState = {
  data: {},
  isLoadMore: false,
  info: {},
  workouts: []
};

export default function(state = initialState, action=null){
  switch (action.type) {
    case FETCH_AUTOMATIONS:
      let isLoadMore = true;
      if (Object.keys(action.payload).length < 10) {
        isLoadMore = false;
      }
      return {
        ...state,
        data: {...state.data, ...action.payload},
        isLoadMore: isLoadMore
      }
    case RESET_AUTOMATIONS:
        return initialState
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/automations.js